export const leagueSteps = [
  'Details',
  'Contacts',
  'Days and Hours',
  'Divisions',
  'Round Robin',
  'Costs',
  'Communications',
  'Settings',
]
